export default __webpack_public_path__ + "static/Tek_Teleporter-877509ec375c32b457bc94c2fa8e5205.png";